import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import styled from 'styled-components';
import { colorPalette, textStyles } from '../../styles/styleGuide';
import withMatch from '@/hocs/withMatch';
import { connect } from 'react-redux';
import { performApiRequest, getApiDataRequest, invalidateApiDataRequest, getEntity } from '../../redux/apiData';
import { updateModalOpenState, clearModalState } from '../../redux/modal';
import { planningItemSchema } from '../../entities/relationSchema';
import ModalInnerWrapper from '../shared/designElements/ModalInnerWrapper';
import DaysCounter from '../shared/designElements/DaysCounter';
import DeleteConfirmation from '../shared/designElements/DeleteConfirmation';
import FormGenerator from '../shared/forms/FormGenerator';
import UserAvatar from '../UserAvatar';
import getDate from '../../services/getDate';
import isEqual from 'lodash.isequal';
import onNetworkStatusChange from '@/processes/onNetworkStatusChange';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  var postActionRequest = getApiDataRequest(state.apiData, 'postAction', {
    projectSlug: String(projectSlug)
  });
  var patchActionRequest = getApiDataRequest(state.apiData, 'patchAction', {
    projectSlug: String(projectSlug),
    actionId: ownProps.id || ''
  });
  return {
    postRequest: getApiDataRequest(state.apiData, 'postAction', {
      projectSlug: String(projectSlug)
    }),
    patchRequest: patchActionRequest,
    deleteRequest: getApiDataRequest(state.apiData, 'deleteAction', {
      projectSlug: String(projectSlug),
      actionId: ownProps.id || ''
    }),
    action: getEntity(state.apiData, planningItemSchema, postActionRequest && postActionRequest.networkStatus === 'success' ? postActionRequest.result : ownProps.uniqueId)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var projectSlug = ownProps.match.params.projectSlug;
  return {
    patchAction: function patchAction(actionId, actionValues) {
      dispatch(performApiRequest('patchAction', {
        projectSlug: String(projectSlug),
        actionId: actionId
      }, _objectSpread({}, actionValues)));
    },
    deleteAction: function deleteAction(actionId) {
      dispatch(performApiRequest('deleteAction', {
        projectSlug: String(projectSlug),
        actionId: actionId
      }));
    },
    postAction: function postAction(actionValues) {
      dispatch(performApiRequest('postAction', {
        projectSlug: String(projectSlug)
      }, _objectSpread({}, actionValues)));
    },
    clearRequest: function clearRequest() {
      dispatch(invalidateApiDataRequest('postAction', {
        projectSlug: String(projectSlug)
      }));
      dispatch(invalidateApiDataRequest('deleteAction', {
        projectSlug: String(projectSlug),
        actionId: ownProps.id || ''
      }));
      dispatch(invalidateApiDataRequest('patchAction', {
        projectSlug: String(projectSlug),
        actionId: ownProps.id || ''
      }));
    },
    invalidateNotifications: function invalidateNotifications() {
      dispatch(invalidateApiDataRequest('getNotifications', {
        projectSlug: String(projectSlug)
      }));
    },
    invalidateGetBlock: function invalidateGetBlock() {
      dispatch(invalidateApiDataRequest('getBlock', {
        projectSlug: String(projectSlug),
        env: 'closed',
        blockId: ownProps.blockId
      }));
    },
    closeModal: function closeModal() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var PlanningActionModal = /*#__PURE__*/function (_Component) {
  function PlanningActionModal() {
    var _this;
    _classCallCheck(this, PlanningActionModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, PlanningActionModal, [].concat(args));
    _defineProperty(_this, "state", {
      mode: _this.props.mode,
      isLoading: false,
      isTransitioning: false
    });
    _defineProperty(_this, "handleModifyAction", function (formValues, actionType) {
      _this.setState({
        isLoading: true
      }, function () {
        var props = _this.props;
        var _ref = props.action || props,
          id = _ref.id;
        var values = {};
        if (formValues) {
          values.accomplished = !!formValues.actionAccomplished;
          if (formValues.deadline && typeof formValues.deadline === 'string') {
            var reverseDate = formValues.deadline.split('-').reverse().join('-');
            values.deadline = reverseDate;
          }
          if (formValues.title) {
            values.title = formValues.title;
          }
          if (formValues.text) {
            values.text = formValues.text;
          }
        }
        switch (actionType) {
          case 'POST':
            props.postAction(_objectSpread({}, values));
            break;
          case 'DELETE':
            props.deleteAction(Number(id));
            break;
          case 'PATCH':
          default:
            props.patchAction(Number(id), _objectSpread({}, values));
            break;
        }
      });
    });
    return _this;
  }
  _inherits(PlanningActionModal, _Component);
  return _createClass(PlanningActionModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        clearRequest = _this$props.clearRequest,
        invalidateNotifications = _this$props.invalidateNotifications;
      // We need to clear the loaded action when the modal is opened after an action has already been added
      // Otherwise the modal will show the title of the last action that has been added to the redux store
      clearRequest();
      invalidateNotifications();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        deleteRequest = _this$props2.deleteRequest,
        postRequest = _this$props2.postRequest,
        patchRequest = _this$props2.patchRequest,
        invalidateGetBlock = _this$props2.invalidateGetBlock,
        closeModal = _this$props2.closeModal,
        action = _this$props2.action;
      var oldAction = prevProps.action;
      var _this$state = this.state,
        isLoading = _this$state.isLoading,
        mode = _this$state.mode;
      if (deleteRequest && deleteRequest.networkStatus === 'success' && this.state.mode !== 'delete') {
        this.setState({
          mode: 'delete'
        });
      } else if (postRequest && postRequest.networkStatus === 'success' && isLoading) {
        this.setState({
          isLoading: false,
          isTransitioning: true
        });

        // When posting an action, we want to transition the contents of the modal.
        // When patching an action, we don't want to transition.
        if (!isEqual(oldAction, action) && mode === 'create') {
          this.transitionFromTo('create', 'read');
        }
      }
      var callbacks = {
        onSucces: invalidateGetBlock,
        always: closeModal
      };
      onNetworkStatusChange(callbacks, prevProps.patchRequest, patchRequest);
      onNetworkStatusChange(callbacks, prevProps.postRequest, postRequest);
      onNetworkStatusChange(callbacks, prevProps.deleteRequest, deleteRequest);
    }
  }, {
    key: "transitionFromTo",
    value: function transitionFromTo(viewCurrent, viewNext) {
      var _this2 = this;
      this.setState({
        isTransitioning: true
      }, function () {
        setTimeout(function () {
          _this2.setState({
            mode: viewNext
          });
        }, 300);
        setTimeout(function () {
          _this2.setState({
            isTransitioning: false
          });
        }, 700);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var props = this.props;
      var _ref2 = props.action || {},
        author = _ref2.author,
        authorType = _ref2.authorType,
        authorImage = _ref2.authorImage,
        functionTitle = _ref2.functionTitle,
        accomplished = _ref2.accomplished,
        deadline = _ref2.deadline,
        editable = _ref2.editable,
        text = _ref2.text,
        title = _ref2.title;
      var editActionForm = [{
        options: [{
          id: 'title',
          name: 'title',
          required: true,
          title: 'Actietitel',
          type: 'text'
        }, {
          id: 'deadline',
          name: 'deadline',
          required: true,
          title: 'Einddatum',
          type: 'bamDate'
        }, {
          id: 'text',
          name: 'text',
          required: true,
          title: 'Beschrijving van je actie',
          type: 'textarea'
        }, {
          id: 'actionAccomplished',
          name: 'actionAccomplished',
          required: false,
          type: 'checkbox',
          title: '',
          choices: [{
            key: 'accomplished',
            value: 'Actie voltooid',
            defaultChecked: accomplished || false
          }]
        }]
      }];
      var defaultTitle = 'Actie aanmaken of beheren';
      var defaultDescription = "Maak de planning persoonlijk met jouw eigen acties. Zo vergeet je nooit meer een belangrijke stap of afspraak!";
      var modalSettings = {
        create: {
          title: defaultTitle,
          description: defaultDescription,
          showAuthor: false,
          form: {
            fields: editActionForm,
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'POST');
            }
          }
        },
        read: {
          title: title,
          description: text,
          deadline: deadline,
          showAuthor: true,
          author: author,
          authorType: authorType,
          authorImage: authorImage,
          functionTitle: functionTitle,
          form: {
            fields: [{
              options: [{
                id: 'actionAccomplished',
                name: 'actionAccomplished',
                title: '',
                required: false,
                type: 'checkbox',
                choices: [{
                  key: 'accomplished',
                  value: 'Actie voltooid',
                  defaultChecked: accomplished || false
                }]
              }]
            }],
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'PATCH');
            },
            showCancel: editable,
            cancelLabel: 'Actie bewerken',
            cancelButtonColor: '#FFFFFF',
            cancelLabelColor: colorPalette.blue,
            cancelFn: function cancelFn() {
              return _this3.transitionFromTo('read', 'update');
            }
          }
        },
        update: {
          title: defaultTitle,
          description: defaultDescription,
          showAuthor: false,
          form: {
            fields: editActionForm,
            defaultValues: {
              text: text || '',
              title: title || '',
              deadline: deadline ? deadline.split('-').reverse().join('-') : '',
              actionAccomplished: accomplished
            },
            submitLabel: 'Opslaan',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction(values, 'PATCH');
            }
          }
        },
        "delete": {
          showAuthor: false,
          confirmation: {
            title: "Weet je zeker dat je de actie \u2018<span>".concat(title || '', "</span>\u2019 wilt verwijderen?"),
            description: 'Deze actie kan niet ongedaan gemaakt worden.',
            submitButtonLabel: 'Verwijderen',
            submitFn: function submitFn(values, action) {
              return _this3.handleModifyAction({}, 'DELETE');
            },
            cancelButtonLabel: 'Actie bewerken',
            cancelFn: function cancelFn() {
              return _this3.transitionFromTo('delete', 'update');
            }
          }
        }
      };
      var _modalSettings$this$s = modalSettings[this.state.mode],
        description = _modalSettings$this$s.description,
        form = _modalSettings$this$s.form,
        confirmation = _modalSettings$this$s.confirmation,
        showAuthor = _modalSettings$this$s.showAuthor;
      return __jsx(ModalInnerWrapper, {
        "data-id": "dashboard_PlanningActionModal_ModalInnerWrapper"
      }, __jsx(ModalView, {
        fadeIn: !this.state.isTransitioning,
        fadeOut: this.state.isTransitioning,
        "data-id": "dashboard_PlanningActionModal_ModalView"
      }, this.state.mode !== 'delete' && __jsx("div", {
        "data-id": "dashboard_PlanningActionModal_div"
      }, deadline && this.state.mode === 'read' && __jsx(Header, {
        "data-id": "dashboard_PlanningActionModal_Header"
      }, __jsx(Deadline, {
        "data-id": "dashboard_PlanningActionModal_Deadline"
      }, getDate(deadline, false)), __jsx(DaysCounter, {
        deadline: deadline,
        "data-id": "dashboard_PlanningActionModal_DaysCounter"
      })), __jsx(Title, {
        "data-id": "dashboard_PlanningActionModal_Title"
      }, this.state.mode === 'create' || this.state.mode === 'update' ? defaultTitle : title), description && __jsx(Description, {
        "data-id": "dashboard_PlanningActionModal_Description"
      }, description), showAuthor && author && authorType && authorImage && __jsx(AuthorContainer, {
        "data-id": "dashboard_PlanningActionModal_AuthorContainer"
      }, __jsx(AuthorIntro, {
        "data-id": "dashboard_PlanningActionModal_AuthorIntro"
      }, "Aangemaakt door: "), __jsx(UserAvatar, {
        mode: "imageLoader",
        size: "normal",
        imageUrl: authorImage,
        "data-id": "dashboard_PlanningActionModal_UserAvatar"
      }), __jsx(AuthorText, {
        "data-id": "dashboard_PlanningActionModal_AuthorText"
      }, functionTitle && __jsx(AuthorTitle, {
        "data-id": "dashboard_PlanningActionModal_AuthorTitle"
      }, functionTitle), __jsx(AuthorName, {
        isCustomer: authorType === 'customer',
        "data-id": "dashboard_PlanningActionModal_AuthorName"
      }, author))), form && __jsx(FormGenerator, _extends({
        loadingLabel: "aanvraag wordt verwerkt",
        submitButtonPosition: "left",
        loading: this.state.isLoading
      }, form, {
        "data-id": "dashboard_PlanningActionModal_FormGenerator"
      }))), confirmation && __jsx(DeleteConfirmation, {
        title: confirmation.title,
        description: confirmation.description,
        submitButtonLabel: "Verwijderen",
        submitFn: confirmation.submitFn,
        cancelButtonLabel: confirmation.cancelButtonLabel,
        loadingLabel: "aanvraag wordt verwerkt",
        loading: this.state.isLoading,
        cancelFn: confirmation.cancelFn,
        "data-id": "dashboard_PlanningActionModal_DeleteConfirmation"
      })));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(PlanningActionModal));
var ModalView = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n\n  #form_cancel {\n    background-color: #ffffff;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.fadeIn ? '1' : props.fadeOut ? '0' : '1';
}, colorPalette.darkBlue);
var Header = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 5rem;\n"])));
var AuthorContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  padding-top: 23rem;\n  padding-bottom: 25rem;\n  border-bottom: 2rem solid ", ";\n  border-top: 2rem solid ", ";\n\n  > div {\n    margin-right: 5rem;\n  }\n"])), colorPalette.lightGrey, colorPalette.lightGrey);
var Deadline = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n"])), textStyles.bodyText, colorPalette.textGrey);
var AuthorIntro = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  ", ";\n  color: ", ";\n  margin-bottom: 10rem;\n  margin-top: 0;\n"])), textStyles.bodyText, colorPalette.textGrey);
var AuthorText = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0;\n  flex-direction: column;\n  justify-content: center;\n"])));
var AuthorTitle = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n"])), textStyles.subTitle, colorPalette.headerGrey);
var AuthorName = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n\n  ", ";\n"])), textStyles.bodyText, colorPalette.textGrey, function (props) {
  return props.isCustomer && "\n    font-weight: bold;\n  ";
});
var Title = styled.h2(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0;\n  margin-bottom: 20rem;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var Description = styled.p(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin-top: 0rem;\n  margin-bottom: 30rem;\n"])), textStyles.bodyText, colorPalette.textGrey);